import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../shared/context/AuthContext";
import { Button } from "../../../shared/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../../shared/components/ui/card";
import {
  Building2,
  MapPin,
  Users,
  Settings,
  ArrowLeft,
  Shield,
} from "lucide-react";
import { toast } from "sonner";

export default function AdminPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  React.useEffect(() => {
    if (user?.role !== "admin") {
      toast.error("Admin access required");
      navigate("/");
    }
  }, [user, navigate]);

  const adminModules = [
    {
      title: "Stations Manager",
      description: "Add, edit, and manage stations. Control station status (active/inactive).",
      icon: Building2,
      path: "/admin/stations",
      color: "text-blue-500",
      bgColor: "bg-blue-500/10",
    },
    {
      title: "Office Locations Manager",
      description: "Manage office locations and employee home bases.",
      icon: MapPin,
      path: "/admin/office-locations",
      color: "text-emerald-500",
      bgColor: "bg-emerald-500/10",
    },
    {
      title: "User Management",
      description: "Assign office locations to users, manage roles, and bulk updates.",
      icon: Users,
      path: "/admin/users",
      color: "text-purple-500",
      bgColor: "bg-purple-500/10",
    },
  ];

  return (
    <div className="p-4 md:p-6" data-testid="admin-page">
      <div className="flex items-center gap-4 mb-6">
        <Button
          variant="ghost"
          onClick={() => navigate("/")}
          className="font-mono text-sm"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
        <h1 className="font-heading font-black text-2xl flex items-center gap-2">
          <Shield className="h-6 w-6 text-[#FF6B00]" />
          Admin Panel
        </h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {adminModules.map((module) => (
          <Card
            key={module.path}
            className="border-2 border-border rounded-none industrial-card cursor-pointer"
            onClick={() => navigate(module.path)}
            data-testid={`admin-module-${module.title.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <CardHeader className="pb-2">
              <div className="flex items-center gap-3">
                <div className={`h-12 w-12 ${module.bgColor} flex items-center justify-center`}>
                  <module.icon className={`h-6 w-6 ${module.color}`} />
                </div>
                <CardTitle className="font-heading font-bold">
                  {module.title}
                </CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                {module.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
